import { empty } from "rxjs/Observer";

export class ConcessionariaModel {
    codConcessionaria: number;
    nomeFantasia: string;
    razaoSocial: string;
    cnpj: string;
    telefone: string;
    responsavel: string;
    endereco: string;
    email: string;
    codGrupo: number;
    codMarca: number;
    codAcesso: string;
    codBasico: string;
    codIntermediario: string;
    codRecomendado: string;
    codRevisoes: string;
    status: number;
    consultor: string;
    cargoUsuario: string;
    email_consultor: string;
    senha_consultor: string;
    cpf_consultor: string;
    cod_consultor: number;
    integracao_consultor: string;
    nome_marca: string;
    logo_marca: string;
    logo_marca_base: string;
    atualizaautomaticamente: number;
    precoosagregados: number;
    modelocardapio: number;
    dms: number;
    osdms: number;
    buscaplaca: number;
    tipoApp: number;
    tipoOferta: string;
    checklist: number;
    checklist_adicional: number;
    documentos: DocumentosModel[];
    consultores: ConsultoresModel[];
    mecanicos: MecanicosModel[];
    mecanico: string;
    email_mecanico: string;
    idEmpresa: string;
    dadosLayout: LayoutModel;
    cod_mecanico: number;
    nivel: number;
    cor1: string;
    cor2: string;
    cor3: string;
    dir_marcas: string;
    parceiros: ParceiroModel[];
    qualidadeFoto: number;
    qualidadeVideo: number;
    storageName: string;
    sas: sasModel;
    alterarValor: string;
    podeDesconto: string;
    maximoDesconto: number;
    textoLegalALert: string
    textoLegalAssinatura: string;
    limiteMensalBuscaPlaca: number;
    saldoBuscaPlaca : number;
    integrado : boolean;
    tipoIntegracao: string;
    temIntegracaoPdv : boolean;
    temIntegracaoBuscaPlaca : boolean;
    temIntegracaoVeiculos : boolean;
    temIntegracaoClientes : boolean;
    temIntegracaoProdutos : boolean;
    temIntegracaoAtendimentos : boolean;
    formularioDeRecepcao: string;
    assinaturaDoCliente: string;
    erp: number;
    vendaEstoqueNegativo: string;
    habilitadaVoucher:string;
    oleoFracionado: string;

    questionario: Questionario[];
    tipoVeiculo: string;

    //Declarando para evitar erro sem noção no login;
    dadosLoja: any;
    // ---------------------------------------------
}

// type ArrayQuestionario = Questionario[] | null
export interface Questionario {
    id: number;
    idTipo?: number;
    tipo?: string;
    nome: string;
}

export class sasModel {
    created_at : string;
    expiration : string;
    sasCode : string;
}

export class DocumentosModel {
    nome: string;
    arquivo: string;
}


export class ConsultoresModel {
    nome: string;
    codigo: string;
    codIntegracao: string;
}

export class MecanicosModel {
    nome: string;
    codigo: string;
    codIntegracao: string;
}

export class LayoutModel {
    codBandeira: string;
    descricao: string;
    fundoBg: string;
    imgDestaque: string;
    imgBandeira: string;
    imgModal: string;
    cor1: string;
    cor2: string;
    cor3: string;
}

export class ParceiroModel {
    codMarcaProduto: string;
    nome: string;
    tipoProduto: string;
    principal: boolean;
    parceiro: boolean;
}

export class PlanoModel {
    descricao: string;
    folder: string;
    id: string;
    logo: string;
    nome: string;
    ordem: string;
    validade: string;
    valor: string;
}



// WEBPACK FOOTER //
// ./src/app/models/ConcessionariaModel.ts